<template>
  <a-modal
    v-model="visible"
    :title="`${formIsEdit ? $t('menu_edit_title') : $t('menu_add_title')} `"
    :maskClosable="false"
    :closable="!formLoading"
    :okText="$t('com_btn_save')"
    @ok="formSubmit"
    @cancel="formReset"
    :confirmLoading="formLoading"
    :cancelButtonProps="{
      props: {
        disabled: formLoading,
      },
    }"
    centered
  >
    <a-form-model
      :model="form"
      :rules="formRules"
      ref="formElement"
      :labelCol="{ span: 6 }"
      :wrapperCol="{ span: 18 }"
    >
      <!-- 父级菜单 -->
      <a-form-model-item :label="$t('menu_interface_form_menu')" prop="parentId">
        <a-tree-select
          v-model="form.parentId"
          style="width: 100%"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="allMenu"
          :placeholder="$t('menu_interface_form_menu_placeholder')"
          tree-default-expand-all
          ref="parentMenu"
          allowClear
        >
        </a-tree-select>
      </a-form-model-item>

      <!-- 名称 -->
      <a-form-model-item :label="$t('menu_form_name')" prop="name">
        <a-input
          v-model="form.name"
          :placeholder="$t('menu_form_name_placeholder')"
          allowClear
          @input="formInput"
          style="width:350px"
          ref="menuName"
        />
      </a-form-model-item>

      <!-- 菜单Auth Name -->
      <a-form-model-item :label="$t('menu_interface_form_auth_name')" prop="authName">
        <a-input
          v-model="form.authName"
          :placeholder="$t('menu_interface_form_auth_name_placeholder')"
          allowClear
          @input="formInput"
          style="width:350px"
        />
      </a-form-model-item>

      <!-- 菜单 url -->
      <a-form-model-item :label="$t('menu_interface_form_url')" prop="url">
        <a-input
          v-model="form.url"
          :placeholder="$t('menu_form_url_placeholder')"
          allowClear
          @input="formInput"
          style="width:350px"
        />
      </a-form-model-item>

      <!-- 通用 -->
      <a-form-model-item
        :label="$t('menu_interface_form_auth_common')"
        prop="common"
        :help="$t('menu_interface_form_auth_common_help')"
      >
        <a-checkbox v-model="form.common"></a-checkbox>
      </a-form-model-item>

      <!-- 禁用 -->
      <a-form-model-item :label="$t('com_form_disabled')" prop="disabled">
        <a-switch v-model="form.disabled" />
      </a-form-model-item>

      <!-- 排序数值 -->
      <a-form-model-item
        :label="$t('menu_form_sort')"
        prop="sort"
        :help="$t('menu_form_sort_help')"
      >
        <a-input-number
          v-model="form.sort"
          :placeholder="$t('menu_form_sort_placeholder')"
          allowClear
          @input="formInput"
          style="width:350px"
        />
      </a-form-model-item>

      <!-- 描述 -->
      <a-form-model-item :label="$t('com_form_remark')" prop="remark" style="margin:0">
        <a-textarea
          v-model="form.remark"
          :placeholder="$t('com_form_remark_placeholder')"
          :rows="2"
          allowClear
          @input="formInput"
        />
      </a-form-model-item>
    </a-form-model>
    <!-- 错误描述 -->
    <div class="form-error-text">
      <Icon type="error" v-if="formError" />
      <p>{{ formError }}</p>
    </div>
  </a-modal>
</template>
<script>
import * as API from '@/api/system/role';

export default {
  props: {
    allMenu: {
      type: Array,
      default: () => [],
    },
    menuInfo: {
      type: Object,
      default: () => {},
    },
    callback: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      // 新增
      visible: false,
      formRules: {
        name: [
          {
            required: true,
            message: this.$t('menu_form_name_placeholder'),
            trigger: 'change',
          },
        ],
        authName: [
          {
            required: true,
            message: this.$t('menu_interface_form_auth_name_placeholder'),
            trigger: 'change',
          },
        ],
        url: [
          {
            required: true,
            message: this.$t('menu_form_url_placeholder'),
            trigger: 'change',
          },
        ],
      },
      // 搜索
      form: {
        // 名称
        name: undefined,
        // 权限值
        authName: undefined,
        // 是否禁用
        disabled: false,
        // 是否隐藏
        hide: false,
        // 父级菜单
        parentId: undefined,
        // 备注
        remark: undefined,
        // 排序
        sort: 0,
        // URL
        url: undefined,
        // 通用
        common: undefined,
      },
      formError: '',
      formIsEdit: '',
      formLoading: false,
    };
  },
  methods: {
    // 更新列表
    updateList() {
      // 更新列表
      this.callback(this.menuInfo);
    },

    // Role - 显示
    show(menuInfo) {
      this.visible = true;
      this.formIsEdit = menuInfo ? true : false;
      // focus name
      this.$nextTick(() => {
        if (this.formIsEdit) {
          // 编辑
          Object.keys(this.form).forEach(key => {
            this.form[key] = menuInfo[key];
          });
          if (!this.form.parentId) {
            this.form.parentId = undefined;
          }
        } else {
          // 添加
          this.formReset();
        }

        this.$refs.menuName && this.$refs.menuName.focus();
      });
    },
    // 菜单添加 - 提交
    formSubmit() {
      this.$refs.formElement.validate(valid => {
        if (valid) {
          this.formLoading = true;
          const params = { ...this.form };
          if (typeof params.parentId === 'undefined') {
            params.parentId = 0;
          }

          if (this.formIsEdit) {
            params.id = this.menuInfo.id;
            // 编辑
            API.MenuEdit(params)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t('com_msg_edit_success'));
                  this.visible = false;
                  this.formReset();
                  // 更新列表
                  this.updateList();
                } else {
                  this.formError = res.message;
                }
              })
              .finally(() => {
                this.formLoading = false;
              });
          } else {
            API.MenuAdd(params)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t('com_msg_add_success'));
                  this.visible = false;
                  this.formReset();
                  // 更新列表
                  this.updateList();
                } else {
                  this.formError = res.message;
                }
              })
              .finally(() => {
                this.formLoading = false;
              });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // Role - error reset
    formInput() {
      this.formError = '';
    },
    // Role - add form reset
    formReset() {
      this.formInput();
      this.$refs.formElement.resetFields();

      Object.keys(this.form).forEach(key => {
        if (key === 'disabled') {
          this.form[key] = false;
        } else if (key === 'hide') {
          this.form[key] = false;
        } else if (key === 'sort') {
          this.form[key] = 999999;
        } else {
          this.form[key] = undefined;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.form-error-text {
  height: 25px;
  line-height: 25px;
  color: #f00;
  display: flex;
  align-items: center;
  p {
    margin: 0 0 0 10px;
    padding: 0;
  }
}
</style>
